<template>
  <div class="main-width">
    <div class="project-search page-search home-height" style="margin-top: -10px; padding-top: 68px">
      <div style="display: flex; flex-direction: column; margin-bottom: 40px">
        <div>
          <p style="font-weight: bold; margin-left: 70px; font-size: 22px">
            Search for Radionuclide in Whole Database:
          </p>
        </div>
        <div style="display: flex; margin: 0 auto">
          <el-input
            v-model="nuclideFullText"
            placeholder="Enter the keyword"
            style="width: 900px; font-size: 20px"
            class="project-input"
          >
          </el-input>
          <el-button
            class="btn-submit page-btn"
            @click="submitNuclideFullText()"
            style="font-size: 22px; width: 120px"
            >Search</el-button
          >
        </div>
        
        <p style="margin-left: 70px; font-size: 18px">
          Example:
          <a
            href="/search-radionuclide?api=fullText&keyword=177Lu"
            hreflang="en"
            class="search-color"
            >177Lu </a
          >; <a
            href="/search-radionuclide?api=fullText&keyword=18F"
            hreflang="en"
            class="search-color"
            >18F</a
          >; <a
            href="/search-radionuclide?api=fullText&keyword=131I"
            hreflang="en"
            class="search-color"
            >131I </a
          >; <a
            href="/search-radionuclide?api=fullText&keyword=225Ac"
            hreflang="en"
            class="search-color"
            >225Ac </a
          >; <a
            href="/search-radionuclide?api=fullText&keyword=68Ga"
            hreflang="en"
            class="search-color"
            >68Ga  </a
          >
          ...
        </p>
      </div>
    </div>

    <div class="project-search page-search" style="margin-top: 50px">
      
      <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 78px; font-size: 22px">
            Search for Radionuclide by Radiation & Radionuclide:
          </p>
        </div>
        <div>
          <p style="margin-left: 78px; font-size: 18px">
            <i class="icon iconfont icon--idea" aria-hidden="true"></i> Tips:
            Please select the radiation first, then a list of radionuclide under the
            selected radiation will be available for selection.
          </p>
        </div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="radiation_list_check"
            v-model="radiation"
            filterable
            default-first-option
            placeholder="Step1: Please select a radiation"
            style="width: 900px"
          >
            <el-option
              v-for="(item, index) in radiation_list"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-button
            class="btn-submit page-btn"
            @click="resetRadiationNuclide()"
            style="font-size: 22px; width: 120px"
            >Reset</el-button
          >
        </div>
        <div style="height: 10px"></div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="nuclide_list_check"
            v-model="nuclide"
            filterable
            default-first-option
            ref="searchSelect"
            placeholder="Step2: Please select a radionuclide"
            style="width: 900px"
          >
            <el-option
              v-for="(item, index) in nuclide_list"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-button
            class="btn-submit page-btn"
            @click="submitRadiationNuclide()"
            style="font-size: 22px; width: 120px"
            >Submit</el-button
          >
        </div>
      </div>

      <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 78px; font-size: 22px">
            Search for Radionuclide by Disease Class & Disease Name:
          </p>
        </div>
        <div>
          <p style="margin-left: 78px; font-size: 18px">
            <i class="icon iconfont icon--idea" aria-hidden="true"></i> Tips:
            Please select the disease class first, then a list of disease name
            under the selected class will be available for selection.
          </p>
        </div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="disease_class_list_check"
            v-model="disease_class"
            filterable
            default-first-option
            placeholder="Step1: Please select a disease class"
            style="width: 900px"
          >
            <el-option
              v-for="(item, index) in disease_class_list"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-button
            class="btn-submit page-btn"
            @click="resetClassDisease()"
            style="font-size: 22px; width: 120px"
            >Reset</el-button
          >
        </div>
        <div style="height: 10px"></div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="disease_name_list_check"
            v-model="disease_name"
            filterable
            default-first-option
            ref="searchSelect"
            placeholder="Step2: Please select a disease name"
            style="width: 900px"
          >
            <el-option
              v-for="(item, index) in disease_name_list"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-button
            class="btn-submit page-btn"
            @click="submitClassDisease()"
            style="font-size: 22px; width: 120px"
            >Submit</el-button
          >
        </div>
      </div>
      <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 78px; font-size: 22px">
            Search for Radionuclide by Drug Type & Drug Name:
          </p>
        </div>
        <div>
          <p style="margin-left: 78px; font-size: 18px">
            <i class="icon iconfont icon--idea" aria-hidden="true"></i> Tips:
            Please select the drug type first, then a list of drug name under
            the selected class will be available for selection.
          </p>
        </div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="drug_type_list_check"
            v-model="drug_type"
            filterable
            default-first-option
            placeholder="Step1: Please select a drug type"
            style="width: 900px"
          >
            <el-option
              v-for="(item, index) in drug_type_list"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-button
            class="btn-submit page-btn"
            @click="resetTypeDrug()"
            style="font-size: 22px; width: 120px"
            >Reset</el-button
          >
        </div>
        <div style="height: 10px"></div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="drug_name_list_check"
            v-model="drug_name"
            filterable
            default-first-option
            ref="searchSelect"
            placeholder="Step2: Please select a drug name"
            style="width: 900px"
          >
            <el-option
              v-for="(item, index) in drug_name_list"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-button
            class="btn-submit page-btn"
            @click="submitTypeDrug()"
            style="font-size: 22px; width: 120px"
            >Submit</el-button
          >
        </div>
      </div>

    </div>
    <div style="height: 20px"></div>
  </div>
</template>
  
  <script>
import api from "@/api/index";
import pathUrl from "@/api/path";

export default {
  data() {
    return {
      localUrl: pathUrl.localUrl,

      nuclideFullText: "",

      drug_type_list_check: true,
      drug_type: "",
      drug_type_list: [],
      drug_name_list_check: false,
      drug_name: "",
      drug_name_list: [],

      radiation_list_check: true,
      radiation: "",
      radiation_list: [],
      nuclide_list_check: false,
      nuclide: "",
      nuclide_list: [],

      disease_class_list_check: true,
      disease_name_list_check: false,
      disease_class: "",
      disease_name: "",
      disease_class_list: [],
      disease_name_list: [],
    };
  },
  components: {
    // DivUnit,
  },

  methods: {
    submitNuclideFullText() {
      this.$router.push({
        path: `/search-radionuclide`,
        query: {
          api: "fullText",
          keyword: this.nuclideFullText,
        },
      });
    },

    submitTypeDrug() {
      this.$router.push({
        path: `/search-radionuclide`,
        query: {
          api: "search-radionuclide-by-drug",
          group: this.drug_type,
          keyword: this.drug_name,
        },
      });
    },
    submitClassDisease() {
      this.$router.push({
        path: `/search-radionuclide`,
        query: {
          api: "search-radionuclide-by-disease",
          group: this.disease_class,
          keyword: this.disease_name,
        },
      });
    },
    submitRadiationNuclide() {
      this.$router.push({
        path: `/search-radionuclide`,
        query: {
          api: "search-radionuclide-by-nuclide",
          group: this.radiation,
          keyword: this.nuclide,
        },
      });
    },
    resetTypeDrug() {
      this.drug_type='';
      this.drug_name='';
    },
    resetClassDisease() {
      this.disease_class='';
      this.disease_name='';
    },
    resetRadiationNuclide() {
      this.radiation='';
      this.nuclide='';
    },
  },

  beforeMount() {},
  mounted() {
    api.getSearchDrugList().then((res) => {
      this.drug_type_list_check = false;
      this.radiation_list_check = false;
      this.disease_class_list_check = false;
      this.drug_type_list = res.data.drug_type_list;
      this.radiation_list = res.data.radiation_list;
      this.disease_class_list = res.data.disease_class_list;
    });
  },
  watch: {
    drug_type: {
      handler: function () {
        this.drug_name_check = true;
        this.drug_name = "";
        api
          .postTypeDrugList({
            data: this.drug_type,
          })
          .then((res) => {
            this.drug_name_list_check = false;
            this.drug_name_list = res.data.drug_name_list;
          });
      },
      deep: true,
    },
    disease_class: {
      handler: function () {
        this.disease_name_check = true;
        this.disease_name = "";
        api
          .postClassDiseaseList({
            data: this.disease_class,
          })
          .then((res) => {
            this.disease_name_list_check = false;
            this.disease_name_list = res.data.disease_name_list;
          });
      },
      deep: true,
    },
    radiation: {
      handler: function () {
        this.nuclide_check = true;
        this.nuclide = "";
        api
          .postRadiationNuclideList({
            data: this.radiation,
          })
          .then((res) => {
            this.nuclide_list_check = false;
            this.nuclide_list = res.data.nuclide_list;
          });
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
@color-theme: #e5795c;
@color-bg: #e5795cba;

/deep/input {
  height: 50px;
  padding-left: 15px;
  font-size: 20px;
  border: 2px solid @color-theme !important;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
  outline: none;
}


.page-search {
  border: 3px solid @color-theme;
  background-color: #fef8f7;
}
.page-search-color {
  color: @color-theme;
}
.search-color{
color: @color-theme;
}
.page-btn {
  background: @color-theme;
}
.page-btn:hover {
  background: @color-bg;
}
.page-btn:hover,
.page-btn:active,
.page-btn:focus {
  background: @color-bg;
}
/deep/.el-button {
  font-size: 22px !important;
  height: 50px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  border: 2px;
}
</style>
  